import _ from "lodash";
import axios from "@util/axios";
import store from "@store";

class MembersService {
	constructor() {
		this.members = store.getters.members;
		this.member = store.getters.member;

		store.subscribe((mutation, state) => {
			this.member = state.members.member;
			this.members = state.members.members;
		});
	}

	set(type = "member", data) {
		if ("list" === type)
			store.commit(
				"GET_MEMBERS",
				data
					? {
							count: data.length,
							results: data,
					  }
					: null
			);
		else
			store.commit(
				data && data.id === this.member.id
					? "UPDATE_MEMBER"
					: "READ_MEMBER",
				data
					? {
							data: data,
					  }
					: null
			);
	}

	async list(params, commit = true) {
		const response = await axios({
			url:
				params && params.company_id
					? `/member/by_company/${params.company_id}/`
					: `/member/`,
			params: _.pick(params, [
				"page",
				"page_size",
				"report_id",
				"assigned",
				"type",
			]),
		});

		if (commit)
			store.commit(
				"GET_MEMBERS",
				params.company_id
					? response.data.data.data.members
					: response.data.data
			);

		return response;
	}

	async listWithAssignedReports(params) {
		const response = await axios({
			url: `/member/report_assigned/`,
			params: _.pick(params, [
				"report_id",
				"company_id",
				"page",
				"page_size",
			]),
		});

		return response;
	}

	async create(data, params = null, commit = true) {
		const response = await axios({
			url: `/member/`,
			method: "POST",
			data: _.pick(data, [
				"company",
				"type",
				"status",
				"display_name",
				"email",
			]),
			params: _.pick(params, ["create_superuser"]),
		});

		if (commit) {
			if (!params || !params.create_superuser)
				store.commit("CREATE_MEMBER", response.data.data);

			store.commit("READ_MEMBER", response.data.data);
		}

		return response;
	}

	async read(data, commit = true) {
		const response = await axios({
			url: `/member/${data.id}/`,
		});

		if (commit) store.commit("READ_MEMBER", response.data.data);

		return response;
	}

	async update(data, commit = true) {
		const response = await axios({
			url: `/member/${data.id}/`,
			method: "PUT",
			data: _.pick(data, [
				"company",
				"type",
				"is_active",
				"display_name",
				"status",
                "cash_call_approver",
			]),
		});

		if (commit) {
			store.commit("UPDATE_MEMBER", response.data.data);

			if (data.id == response.data.data.data.id)
				store.commit("READ_MEMBER", response.data.data);
		}

		return response;
	}

	async delete(data, commit = true) {
		const response = await axios({
			url: `/member/${data.id}/`,
			method: "DELETE",
		});

		if (commit)
			store.commit("DELETE_MEMBER", {
				data: data,
			});

		return response;
	}

	async approve(data, commit = true) {
		const response = await axios({
			url: `/auth/user/approved/${data.user_id}/`,
			method: "PUT",
			data: _.pick(data, ["type", "status"]),
		});

		if (commit) {
			store.commit("UPDATE_MEMBER", response.data.data);

			if (this.member.id == response.data.data.data.id)
				store.commit("READ_MEMBER", response.data.data);
		}
	}

	async assignCompany(data) {
		const response = await axios({
			url: `/member/assigned/company/${data.company_id}/${data.member_id}/${data.type}/`,
			method: "POST",
			data: _.pick(data, ["type", "status"]),
		});

		return response;
	}

	async unassignCompany(data) {
		data.company = null;

		const response = await axios({
			url: `/member/${data.id}/`,
			method: "PUT",
			data: _.pick(data, [
				"company",
				"type",
				"is_active",
				"display_name",
				"status",
			]),
		});

		return response;
	}

	async getUserByEmail(email) {
		const response = await axios({
			url: `/member/get_user_by_email/${email}`,
		});

		return response;
	}
}

export default new MembersService();
